export default function (props: any) {
    return (
        <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="mobile" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MH200详情/mobile" transform="translate(-224.000000, -2012.000000)" fill="#FFFFFF">
                    <g id="编组-8" transform="translate(69.000000, 1948.000000)">
                        <g id="编组-7" transform="translate(56.000000, 56.000000)">
                            <g id="编组-6" transform="translate(10.839359, 8.350000)">
                                <g id="03-icon" transform="translate(89.000000, 0.000000)">
                                    <path
                                        d="M8.9821366,1 C13.4004146,1 16.9821366,4.581722 16.9821366,9 C16.9821366,13.418278 13.4004146,17 8.9821366,17 C4.5638586,17 0.982136596,13.418278 0.982136596,9 C0.982136596,4.581722 4.5638586,1 8.9821366,1 Z M7.35388937,6.04562074 C7.12178051,6.04562074 6.9336191,6.23378215 6.9336191,6.46589101 L6.9336191,6.46589101 L6.9336191,11.6610934 C6.9336191,11.7386428 6.95507598,11.8146801 6.995615,11.8807899 C7.11695006,12.0786594 7.37571645,12.1407028 7.57358592,12.0193677 L7.57358592,12.0193677 L11.809674,9.42176656 C11.8661418,9.38714007 11.9136253,9.33965656 11.9482518,9.28318874 C12.0695869,9.08531927 12.0075435,8.82655287 11.809674,8.70521782 L11.809674,8.70521782 L7.57358592,6.10761664 C7.50747614,6.06707762 7.43143882,6.04562074 7.35388937,6.04562074 Z"
                                        id="椭圆形-2"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
